import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../AuthContext";

import { FaPlus, FaStar, FaRegStar, FaBell } from "react-icons/fa";

import Navbar from "../../components/Navbar.js";
import Card from "../../components/Card.js";

function Home() {
  const [data, setData] = useState([]);
  const [activeButton, setActiveButton] = useState("BEST");
  const { loggedIn, user } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch("https://uplbidet-api.vercel.app/api/cr/available");
        if (!res.ok) {
          throw new Error("An error has occured.");
        }

        const jsonData = await res.json();
        setData(jsonData);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, []);

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  const sortDescending = () => {
    return data.slice().sort((a, b) => b.average_rating - a.average_rating);
  };

  const sortAscending = () => {
    return data.slice().sort((a, b) => a.average_rating - b.average_rating);
  };

  const sortRecent = () => {
    return data.slice().sort((a, b) => {
      const latestReviewA = a.recent_review;
      const latestReviewB = b.recent_review;

      if (!latestReviewA || !latestReviewB) {
        return 0;
      }

      const timePublishedA = new Date(latestReviewA.time_published).getTime();
      const timePublishedB = new Date(latestReviewB.time_published).getTime();

      return timePublishedB - timePublishedA;
    });
  };

  const renderCards = () => {
    let sortedData;

    switch (activeButton) {
      case "BEST":
        sortedData = sortDescending();
        break;
      case "WORST":
        sortedData = sortAscending();
        break;
      case "RECENT":
        sortedData = sortRecent();
        break;
      default:
        sortedData = data;
    }

    return sortedData.map((item) => (
      <Link
        key={item._id}
        to={`/detail/${item._id}`}
        style={{ textDecoration: "none", color: "black" }}
      >
        <Card data={item} activeButton={activeButton} />
      </Link>
    ));
  };

  return (
    <>
      <Navbar passedState={loggedIn} user={user} />

      <div className="main-content">
        <div className="container">
          <h1 className="heading">Explore campus restrooms</h1>
          <div className="hr"></div>
          <div className="main-content-group">
            <div className="card-gallery">{renderCards()}</div>
            <div
              className={
                loggedIn
                  ? "card-buttons-container active"
                  : "card-buttons-container"
              }
            >
              {loggedIn ? (
                <Link to="/new-bathroom" className="button highlight">
                  <FaPlus />
                  <span>NEW</span>
                </Link>
              ) : (
                <Link to="/login" className="button highlight">
                  <FaPlus />
                  <span>NEW</span>
                </Link>
              )}
              <Link
                to="#"
                className={`button regular ${
                  activeButton === "BEST" ? "active" : ""
                }`}
                onClick={() => handleButtonClick("BEST")}
              >
                <FaRegStar />
                <span>BEST</span>
              </Link>
              <Link
                to="#"
                className={`button regular ${
                  activeButton === "WORST" ? "active" : ""
                }`}
                onClick={() => handleButtonClick("WORST")}
              >
                <FaStar />
                <span>WORST</span>
              </Link>
              <Link
                to="#"
                className={`button regular ${
                  activeButton === "RECENT" ? "active" : ""
                }`}
                onClick={() => handleButtonClick("RECENT")}
              >
                <FaBell />
                <span>RECENT ACTIVITY</span>
              </Link>
              <p>
                Discover what the UPLB community think about their restrooms.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
